import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, mergeProps as _mergeProps, withCtx as _withCtx, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-67b885ed"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white add-user-card" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_3 = {
  class: "tab-pane fade show active p-10",
  id: "home-tab-pane",
  role: "tabpanel",
  tabindex: "0"
}
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-md-3" }
const _hoisted_6 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Date ", -1))
const _hoisted_8 = { class: "col-md-3" }
const _hoisted_9 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Montant ", -1))
const _hoisted_11 = { class: "col-md-12" }
const _hoisted_12 = {
  class: "card",
  style: {"padding":"0px !important"}
}
const _hoisted_13 = { class: "card-header d-flex justify-content-between align-items-center" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "card-title mb-0" }, "magasins", -1))
const _hoisted_15 = { class: "card-body" }
const _hoisted_16 = { class: "table-responsive" }
const _hoisted_17 = { class: "table w-100" }
const _hoisted_18 = { style: {"width":"100% !important"} }
const _hoisted_19 = { style: {"margin-bottom":"5px !important","width":"100% !important"} }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"clear":"both"} }, null, -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_22 = { class: "col-md-12" }
const _hoisted_23 = {
  class: "card",
  style: {"padding":"0px !important"}
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header d-flex justify-content-between align-items-center" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "card-title mb-0" }, "produit conditionnement")
], -1))
const _hoisted_25 = { class: "card-body" }
const _hoisted_26 = { class: "table" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Produit"),
    /*#__PURE__*/_createElementVNode("th", null, "Quantité"),
    /*#__PURE__*/_createElementVNode("th", null, "Prix Achat"),
    /*#__PURE__*/_createElementVNode("th")
  ])
], -1))
const _hoisted_28 = { style: {"margin-bottom":"5px !important","min-width":"300px !important"} }
const _hoisted_29 = ["onClick"]
const _hoisted_30 = { class: "card-footer" }
const _hoisted_31 = ["onClick"]
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"clear":"both"} }, null, -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_34 = { class: "row" }
const _hoisted_35 = { class: "col-md-12" }
const _hoisted_36 = { class: "d-flex align-items-center" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "default-btn me-20 transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16 bg-success",
  type: "submit"
}, " Enregistrer ", -1))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-delete lh-1 me-1 position-relative top-2" }, null, -1))
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "position-relative" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Form, {
        ref: "elementForm",
        onSubmit: _ctx.addElement,
        "validation-schema": _ctx.elementSchema
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _hoisted_7,
                  _createVNode(_component_Field, {
                    name: "dateAppro",
                    type: "date",
                    value: _ctx.getCurrentDate(),
                    class: "form-control shadow-none fs-md-15 text-black"
                  }, null, 8, ["value"]),
                  _createVNode(_component_ErrorMessage, {
                    name: "dateAppro",
                    class: "text-danger"
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _hoisted_10,
                  _createVNode(_component_Field, {
                    name: "montant",
                    type: "text",
                    modelValue: _ctx.montantTotal,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.montantTotal) = $event)),
                    class: "form-control shadow-none fs-md-15 text-black"
                  }, null, 8, ["modelValue"]),
                  _createVNode(_component_ErrorMessage, {
                    name: "montant",
                    class: "text-danger"
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _hoisted_14,
                    _createElementVNode("button", {
                      type: "button",
                      class: "default-btn transition border-0 fw-medium text-white pt-6 pb-6 ps-25 pe-25 pt-md-5 pb-md-5 ps-md-20 pe-md-20 rounded-1 fs-md-15 fs-lg-16",
                      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.addApproMag && _ctx.addApproMag(...args)))
                    }, " + Magasin ")
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("table", _hoisted_17, [
                        _createElementVNode("tbody", _hoisted_18, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.approMags, (mg, index) => {
                            return (_openBlock(), _createElementBlock("tr", { key: index }, [
                              _createElementVNode("td", _hoisted_19, [
                                _createVNode(_component_Field, {
                                  name: 'mg_'+index,
                                  modelValue: mg.magasin,
                                  "onUpdate:modelValue": ($event: any) => ((mg.magasin) = $event),
                                  style: {"min-width":"100px !important"}
                                }, {
                                  default: _withCtx(({ field }) => [
                                    _createVNode(_component_Multiselect, _mergeProps({
                                      modelValue: field.value,
                                      "onUpdate:modelValue": ($event: any) => ((field.value) = $event),
                                      ref_for: true
                                    }, field, {
                                      options: _ctx.getFilteredOptions(index),
                                      searchable: true,
                                      placeholder: "Rechercher un magasin",
                                      noResultText: "Aucun enregistrement trouvé",
                                      noOptionsText: "Tapez au moins deux caractères"
                                    }), null, 16, ["modelValue", "onUpdate:modelValue", "options"])
                                  ]),
                                  _: 2
                                }, 1032, ["name", "modelValue", "onUpdate:modelValue"]),
                                _createVNode(_component_ErrorMessage, {
                                  name: 'mg_'+index,
                                  class: "text-danger"
                                }, null, 8, ["name"]),
                                _hoisted_20,
                                _createTextVNode(),
                                _hoisted_21,
                                _createElementVNode("div", _hoisted_22, [
                                  _createElementVNode("div", _hoisted_23, [
                                    _hoisted_24,
                                    _createElementVNode("div", _hoisted_25, [
                                      _createElementVNode("table", _hoisted_26, [
                                        _hoisted_27,
                                        _createElementVNode("tbody", null, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(mg.approMagProdConds, (pro, pIndex) => {
                                            return (_openBlock(), _createElementBlock("tr", { key: pIndex }, [
                                              _createElementVNode("td", _hoisted_28, [
                                                _createVNode(_component_Field, {
                                                  name: 'pro_pro'+index+'_'+pIndex,
                                                  modelValue: pro.produitConditionnement,
                                                  "onUpdate:modelValue": ($event: any) => ((pro.produitConditionnement) = $event),
                                                  style: {"min-width":"100px !important"}
                                                }, {
                                                  default: _withCtx(({ field }) => [
                                                    _createVNode(_component_Multiselect, _mergeProps({
                                                      modelValue: field.value,
                                                      "onUpdate:modelValue": ($event: any) => ((field.value) = $event),
                                                      ref_for: true
                                                    }, field, {
                                                      options: _ctx.getFilteredOptionsPC(index,pIndex),
                                                      searchable: true,
                                                      placeholder: "Rechercher un produit",
                                                      noResultText: "Aucun enregistrement trouvé",
                                                      noOptionsText: "Tapez au moins deux caractères"
                                                    }), null, 16, ["modelValue", "onUpdate:modelValue", "options"])
                                                  ]),
                                                  _: 2
                                                }, 1032, ["name", "modelValue", "onUpdate:modelValue"]),
                                                _createVNode(_component_ErrorMessage, {
                                                  name: 'pro_'+index+'_'+pIndex,
                                                  class: "text-danger"
                                                }, null, 8, ["name"])
                                              ]),
                                              _createElementVNode("td", null, [
                                                _createVNode(_component_Field, {
                                                  name: 'pro_qt'+index+'_'+pIndex,
                                                  type: "text",
                                                  modelValue: pro.qteAppro,
                                                  "onUpdate:modelValue": ($event: any) => ((pro.qteAppro) = $event),
                                                  class: "form-control shadow-none fs-md-15 text-black",
                                                  placeholder: "0"
                                                }, null, 8, ["name", "modelValue", "onUpdate:modelValue"]),
                                                _createVNode(_component_ErrorMessage, {
                                                  name: 'pro_qt'+index+'_'+pIndex,
                                                  class: "text-danger"
                                                }, null, 8, ["name"])
                                              ]),
                                              _createElementVNode("td", null, [
                                                _createVNode(_component_Field, {
                                                  name: 'pro_pa'+index+'_'+pIndex,
                                                  type: "text",
                                                  modelValue: pro.prixAchat,
                                                  "onUpdate:modelValue": ($event: any) => ((pro.prixAchat) = $event),
                                                  class: "form-control shadow-none fs-md-15 text-black",
                                                  placeholder: "0"
                                                }, null, 8, ["name", "modelValue", "onUpdate:modelValue"]),
                                                _createVNode(_component_ErrorMessage, {
                                                  name: 'pro_pa'+index+'_'+pIndex,
                                                  class: "text-danger"
                                                }, null, 8, ["name"])
                                              ]),
                                              _createElementVNode("td", null, [
                                                _createVNode(_component_Field, {
                                                  name: 'pro_total_ligne'+index+'_'+pIndex,
                                                  type: "text",
                                                  modelValue: pro.totalLigne,
                                                  "onUpdate:modelValue": ($event: any) => ((pro.totalLigne) = $event),
                                                  class: "form-control shadow-none fs-md-15 text-black",
                                                  placeholder: "0"
                                                }, null, 8, ["name", "modelValue", "onUpdate:modelValue"]),
                                                _createVNode(_component_ErrorMessage, {
                                                  name: 'pro_pa'+index+'_'+pIndex,
                                                  class: "text-danger"
                                                }, null, 8, ["name"])
                                              ]),
                                              _createElementVNode("td", null, [
                                                _createElementVNode("button", {
                                                  type: "button",
                                                  class: "btn btn-sm btn-outline-danger",
                                                  onClick: ($event: any) => (_ctx.removeLigne(index,pIndex))
                                                }, " x ", 8, _hoisted_29)
                                              ])
                                            ]))
                                          }), 128))
                                        ])
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_30, [
                                      _createElementVNode("button", {
                                        type: "button",
                                        class: "default-btn transition border-0 fw-medium text-white pt-6 pb-6 ps-25 pe-25 pt-md-5 pb-md-5 ps-md-20 pe-md-20 rounded-1 fs-md-15 fs-lg-16",
                                        onClick: ($event: any) => (_ctx.addApproMagProdCond(index))
                                      }, " + produit conditionnement ", 8, _hoisted_31)
                                    ])
                                  ])
                                ])
                              ])
                            ]))
                          }), 128))
                        ])
                      ])
                    ])
                  ])
                ])
              ]),
              _hoisted_32,
              _hoisted_33
            ])
          ]),
          _createElementVNode("div", _hoisted_34, [
            _createElementVNode("div", _hoisted_35, [
              _createElementVNode("div", _hoisted_36, [
                _hoisted_37,
                _createVNode(_component_router_link, {
                  to: "/Approvisionnements",
                  class: "btn btn-danger transition border-0 lh-1 fw-medium"
                }, {
                  default: _withCtx(() => [
                    _hoisted_38,
                    _hoisted_39,
                    _createTextVNode("Annuler ")
                  ]),
                  _: 1
                })
              ])
            ])
          ])
        ]),
        _: 1
      }, 8, ["onSubmit", "validation-schema"])
    ])
  ]))
}